import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { LawyersApiService } from 'src/app/core/services/api/lawyers-api.service';
import { cities } from 'src/app/shared/models/cities';
import { countries } from 'src/app/shared/models/countries';
import { Lawyer } from 'src/app/shared/models/lawyers/lawyer';
import { Department } from '../../models/lawyers/department';
import { LawyerLevel } from '../../models/lawyers/lawyerLevel';
import { SearchParams } from '../../models/searchParams';
import { DepartmentCreateEditComponent } from '../department-create-edit/department-create-edit.component';
import { PositionsCreateEditComponent } from '../positions-create-edit/positions-create-edit.component';

@Component({
  selector: 'app-lawyer-create-edit',
  templateUrl: './lawyer-create-edit.component.html',
  styleUrls: ['./lawyer-create-edit.component.scss']
})
export class LawyerCreateEditComponent implements OnInit {
  public lawyer: Lawyer;
  public cities = cities;
  public countries = countries;

  /*
* LawyerLevel ng select
*/
  public positions: LawyerLevel[] = [];
  public positionsLoading = false;
  public positionsHasNext = true;
  public positionParams: SearchParams = new SearchParams();
  @ViewChild('positionModal') positionModal: PositionsCreateEditComponent;
  /*
* Department ng select
*/
  public departments: Department[] = [];
  public departmentsLoading = false;
  public departmentsHasNext = true;
  public departmentParams: SearchParams = new SearchParams();
  @ViewChild('departmentModal') departmentModal: DepartmentCreateEditComponent;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();


  @ViewChild('lawyerModal') lawyerModal;
  @Output() lawyerSubmit: EventEmitter<Lawyer> = new EventEmitter<Lawyer>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: LawyersApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
  }

  // handle the popup
  open(lawyer: Lawyer) {
    this.lawyer = Object.assign(new Lawyer(), lawyer);
    this.modalRef = this.modalService.open(this.lawyerModal, {
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
      centered: true
    });
  }

  close() {
    this.closeModal.emit();
    this.modalRef.close();
  }

  onSubmit() {
    this.spinner.show();
    this.lawyer.levelId = this.lawyer.level?.id;
    const url = this.lawyer.id ? this.api.updateLawyer(this.lawyer) : this.api.createLawyer(this.lawyer);
    url.subscribe(
      c => {
        this.spinner.hide();
        this.lawyerSubmit.emit(c);
        this.closeModal.emit();
      }
    )
  }


  onScrollToEndPositions() {
    if (!this.positionsHasNext) {
      return
    }
    this.positionParams.page++;
    this.loadPositions();
  }

  searchPositions(e) {
    this.positionParams.search = e.term;
    if (!this.positionsLoading) {
      this.positionsLoading = true;
      setTimeout(() => {
        this.positionParams.page = 1;
        this.positions = [];
        this.loadPositions();
      }, 1000);
    }
  }

  openPositions() {
    this.positionParams.search = "";
    this.positionParams.page = 1;
    this.positions = [];
    this.loadPositions();
  }

  loadPositions() {
    this.positionsLoading = true;
    this.api.getLawyerLevels(this.positionParams).subscribe(
      r => {
        this.positionsLoading = false;
        this.positionsHasNext = r.next !== null;
        if (this.positions.length > 0) {
          this.positions = this.positions.concat(r.results);
        } else {
          this.positions = r.results;
        }
      }, errors => {
        this.positionsLoading = false;
        alert('There was a problem with fetching positions');
      }
    )
  }

  positionSubmit(position: LawyerLevel) {
    this.positions = this.positions.concat(position);
    this.lawyer.level = position;
    this.positionModal.close();
    this.toastr.success('Position added', 'Success!');
  }
  onclosePositionModal() {
    document.querySelector('.modal').classList.add('d-block')
  }

  openDepartments() {
    this.departmentParams.search = "";
    this.departmentParams.page = 1;
    this.departments = [];
    this.loadDepartments();
  }

  onScrollToEndDepartments() {
    if (!this.departmentsHasNext) {
      return
    }
    this.departmentParams.page++;
    this.loadDepartments();
  }

  searchDepartments(e) {
    this.departmentParams.search = e.term;
    if (!this.departmentsLoading) {
      this.departmentsLoading = true;
      setTimeout(() => {
        this.departmentParams.page = 1;
        this.departments = [];
        this.loadDepartments();
      }, 1000);
    }
  }

  loadDepartments() {
    this.departmentsLoading = true;
    this.api.getDepartments(this.departmentParams).subscribe(
      r => {
        this.departmentsLoading = false;
        this.departmentsHasNext = r.next !== null;
        if (this.departments.length > 0) {
          this.departments = this.departments.concat(r.results);
        } else {
          this.departments = r.results;
        }
      }, errors => {
        this.departmentsLoading = false;
        alert('There was a problem with fetching departments');
      }
    )
  }


  departmentSubmit(department: Department) {
    this.departments = this.departments.concat(department);
    this.lawyer.departments = this.lawyer.departments.concat(department);
    this.departmentModal.close();
    this.toastr.success('Department added', 'Success!');
  }
  oncloseDeptModal() {
    document.querySelector('.modal').classList.add('d-block');
  }


  updateRate(position) {
    this.lawyer.rate = position ? position.rate : null;
  }


  addPositionFn = (position) => {
    document.querySelector('.modal').classList.remove('d-block');
    this.addItemFn(new LawyerLevel(), position, this.positionModal, 'name');
  }

  addDepartmentFn = (dept) => {
    document.querySelector('.modal').classList.remove('d-block');
    this.addItemFn(new Department(), dept, this.departmentModal, 'name');
  }

  addItemFn = (item: any, value: string, itemModal: any, prop: string, propAr: string = null) => {
    if (/^[\u0600-\u06FF]{1,}/.test(value) && propAr) {
      item[propAr] = value;
    } else {
      item[prop] = value;
    }
    itemModal.open(item);
  }

}
